<div class="definition-tile" (mousedown)="onMouseDown($event)"
     [class.crossword-20]="crosswordBoardConfig.configPreset==='20'">
  <div class="definition-item" *ngIf="tile.words.horizontal"
       (click)="onDefinitionClicked($event, tile.words.horizontal)">
    <div class="definition-line" *ngFor="let item of tile.words.horizontal.definText">
      <span class="definition-line-content">{{ item }}</span>
    </div>
  </div>
  <div class="definition-item" *ngIf="tile.words.vertical" (click)="onDefinitionClicked($event, tile.words.vertical)">
    <div class="definition-line" *ngFor="let item of tile.words.vertical.definText">
      <span class="definition-line-content">{{ item }}</span>
    </div>
  </div>
</div>
<div *ngFor="let arrow of tile.arrows" [ngClass]="[arrow, 'krupion-arrow']"></div>
